/*global $, $mobileTabs, $personPage, closeCallouts, initializeMobileTabs, removeSticky, ui, window */
/****************************************
	person-sticky-tabs.js
*****************************************/
/* Globals */
var $mobileTabs = $('.tabActive > .personPage .mobilePageTabs'),
	$personPage = $('.tabActive > .personPage');
function removeSticky() {
	'use strict';
	$personPage.removeClass('personPageSticky');
	$mobileTabs.removeClass('bgDark bgColor1');
	$('#personHintsTabRegion > .conHeader').removeClass('bgDark bgColor1'); /* Hints Tab Specific */
}
function initializeMobileTabs(activeTab) {
	'use strict';
	var tabIndex;
	function setActiveTab() {
		if ($mobileTabs.find('.tabActive').attr('data-tab-index')) {
			tabIndex = $mobileTabs.find('.tabActive').attr('data-tab-index');
		} else {
			tabIndex = 0;
		}
	}
	if (activeTab) {
		tabIndex = activeTab;
	} else {
		setActiveTab();
	}
	$mobileTabs.tabs({
		'activeIndex': tabIndex,
		'onOpen': function (tab) {
			if (window.personScreenType('smart-phone-portrait')) {
				$(this)
					.on('click', '.tab', function () {
						if ($personPage.hasClass('personPageSticky')) {
							$('html, body').animate({
								scrollTop: $('.personViewPages').offset().top
							}, 0, 'swing', function () {
								removeSticky();
							});
						}
					});
			}
			$(this)
				.next('.tabOptions')
				.attr('class', 'tabOptions tabOptions' + tab);
		},
		'overrideOverflow': true
	});
}
/* On Ready */
$(function () {
	'use strict';
	function checkMobileTabs() {
		if (window.personScreenType('smart-phone')) {
			if (!$mobileTabs.data('tabsInstance')) {
				initializeMobileTabs();
			} else {
				if (window.personScreenType('smart-phone-portrait')) {
					if ($personPage[0].getBoundingClientRect().top < 0) {
						$personPage.addClass('personPageSticky');
						$mobileTabs.addClass('bgDark bgColor1');
						$('#personHintsTabRegion > .conHeader').addClass('bgDark bgColor1'); /* Hints Tab Specific */
						closeCallouts();
					} else {
						removeSticky();
					}
				} else {
					removeSticky();
				}
			}
		} else {
			if ($mobileTabs.data('tabsInstance')) {
				$mobileTabs.tabs('destroy');
				removeSticky();
			}
		}
	}
	$(window)
		.resize(ui.debounce(function () {
			checkMobileTabs();
		}, 25))
		.off('scroll.mobileStickyTabs')
		.on('scroll.mobileStickyTabs', ui.throttle(function () {
			checkMobileTabs();
		}, 25));
	if (window.personScreenType('smart-phone')) {
		initializeMobileTabs();
	}
});